import { API } from "aws-amplify";
import "containers/common/List.css";
import React, { Component } from "react";
import { Alert, Button, Col, Modal, Row } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import ReactTable from "react-table";
import 'react-table/react-table.css';
import { PacmanLoader } from 'react-spinners';
//import Moment from "moment";


export default class HeadOfficeList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            headoffices: [],
            filter: {},
            showAlert: false,
            showWarning: false,
            warningMessage: null,
            errorMessage: "",
        };

        
        
        
        
    }
    

    async componentDidMount() {
        console.log("In HeadOfficeList componentDidMount");
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        if(this.props.filter!=={})
{        try {
            this.setState({ isLoading: true });      
            const headoffices = await this.getHeadOffices(this.props.filter);
            this.setState({ headoffices });
        } catch (e) {
            alert(e);
        }}

        this.setState({ isLoading: false });      
    }

    componentWillUnmount() {
        this.setState({ entities: [] });
    }

    async componentDidUpdate(prevProps) {
        


        if (prevProps.filter !== this.props.filter) {
            this.setState({ isLoading: true });      
            const headoffices = await this.getHeadOffices(this.props.filter);
            
            this.setState({ headoffices });
            this.setState({ isLoading: false });     
        }
    }


    getHeadOffices(filter) {
        console.log("Inside getHeadOffices() ");
        console.log(filter);
        return API.get("colin", "/headoffices", {'queryStringParameters': filter});
      
    }


    renderTable(data) {
        const columns = [

            {
                id: 'led_head_office_id',
                Header: 'Head Office ID',
                maxWidth: 60,
                accessor: 'led_head_office_id' ,
                Cell: e => <a target="_blank" rel="noopener noreferrer" href={`headoffices/${e.value}`}> {e.value} </a>

        }, {
                id: 'tenant_name',
                Header: 'Name',
            
                accessor: 'tenant_name'

            }, {
                id: 'address_line_1',
                Header: 'Address Line 1',
                maxWidth: 200,
                accessor: 'address_line_1'

            }, {
                id: 'address_line_2',
                Header: 'Address Line 2',
                maxWidth: 200,
                accessor: 'address_line_2'

            }, {
                id: 'suburb',
                Header: 'Suburb',
                maxWidth: 200,
                accessor: 'suburb'

            },{
                id: 'state',
                Header: 'State',
                maxWidth: 200,
                accessor: 'state'

            },{
                id: 'postcode',
                Header: 'Postcode',
                maxWidth: 200,
                accessor: 'postcode'

            },
            {
                id: 'email',
                Header: 'Email',
                maxWidth: 200,
                accessor: 'email'

            },
            {
                id: 'telephone',
                Header: 'Telephone',
                maxWidth: 200,
                accessor: 'telephone'

            }
            
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={20}
                    sortable={false}
                />
            )
        }



    }
    
     
    handleAddHeadOfficeLease = async event => {
        let data = [...this.props.data];
        
        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        let headOfficeLease ={
                            led_head_office_id: event.original.led_head_office_id,
                            lease_id: this.props.leaseid,
                        
                            created_by: this.props.user,
                            last_edited_by: this.props.user,
                            new_record: true

                        }
        data.push(headOfficeLease);
        this.props.updateTableState(data, "headofficeleases");
        const result = await this.props.saveRecord(headOfficeLease, "headOfficeLeases", "led_head_office_lease_id");
        
        if (!result.result) {                           
            this.setState({ errorMessage: result.error_message });
            this.setState({ showAlert: true });
        }
        else{
            this.props.toggleHeadOfficeSearchDialog();
        }

    }

    renderTable2(data) {
        const columns = [

            {
                id: 'led_head_office_id',
                Header: 'Head Office ID',
                maxWidth: 60,
                accessor: 'led_head_office_id' ,
                Cell: e => <a target="_blank" rel="noopener noreferrer" href={`headoffices/${e.value}`}> {e.value} </a>

        }, {
                id: 'tenant_name',
                Header: 'Name',
            
                accessor: 'tenant_name'

            }, {
                id: 'address_line_1',
                Header: 'Address Line 1',
                maxWidth: 200,
                accessor: 'address_line_1'

            }, {
                id: 'address_line_2',
                Header: 'Address Line 2',
                maxWidth: 200,
                accessor: 'address_line_2'

            }, {
                id: 'suburb',
                Header: 'Suburb',
                maxWidth: 200,
                accessor: 'suburb'

            },{
                id: 'state',
                Header: 'State',
                maxWidth: 200,
                accessor: 'state'

            },{
                id: 'postcode',
                Header: 'Postcode',
                maxWidth: 200,
                accessor: 'postcode'

            },
            {
                id: 'email',
                Header: 'Email',
                maxWidth: 200,
                accessor: 'email'

            },
            {
                id: 'telephone',
                Header: 'Telephone',
                maxWidth: 200,
                accessor: 'telephone'

            },
            {
                Header: '',
                accessor: 'head_office_id',
                maxWidth: 180,
                Cell: row => <Button type="button" size="sm" variant="primary" onClick={(e) => this.handleAddHeadOfficeLease(row,e)}>Link to Lease</Button>
            }
            
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={10}
                    sortable={false}
                />
            )
        }



    }
    

    
    renderHeadOffices() {
        return (
            <div className="entities">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                <Row >
                    <Col className="text-right" >
                            <LinkContainer to={`/headoffices/new`}>
                                <Button variant="primary"
                                
                                >Add</Button>
                                </LinkContainer>
                            
                                
                                
                        </Col>
                    </Row>
                    {this.props.controlType==="table"&&
                     <Row>
                        <Col><b>{this.state.headoffices.length} of {this.state.headoffices.length>0 ? this.state.headoffices[0].result_count: "0"} records returned.</b></Col>
                    </Row>
                    }

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                        {this.state.isLoading &&
                    <div className="outer-div"><div className='sweet-loading inner-div' >
                        <PacmanLoader
                            css="display: block;
                            margin: 0 auto;
                             border-color: red"
                        sizeUnit={"px"}
                        size={20}
                        color={'#e03c31'}
                        loading={this.state.isLoading}
                        />
                </div>
                    </div>}
                        {!this.state.isLoading ? this.props.controlType == "table" ? this.renderTable(this.state.headoffices) : this.props.controlType == "table2" ? this.renderTable2(this.props.data) : this.renderTable([]) : this.renderTable([])  }
                        </Col>
                    </Row>
           

            </div>
        );
    }
  render() {
    return (

        <div className="HeadOfficeList">
            {this.props.isAuthenticated ? this.renderHeadOffices() : console.log("error)")}
            
        </div>
    );
  }
}
